import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import Icon from "../../../../components/selfcare/Icon.tsx";
import {Link} from "react-router-dom";
import IconArrow from "../../../../components/icons/IconArrow.tsx";

export default function WifiFrekvenserArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            2,4&nbsp;GHz og 5&nbsp;GHz er to forskellige frekvenser, dit wifi bruger til at sende et trådløst signal fra din router til din enhed.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Hvornår skal jeg bruge 2,4&nbsp;GHz eller 5&nbsp;GHz?
                        </h2>
                        <p>
                            Vi anbefaler, at du bruger dit 5 GHz.
                            Afhængigt af din position kan du dog skifte mellem 2,4 GHz og 5 GHz for at opnå den bedste forbindelse.
                        </p>
                        <p>
                            5 GHz er hurtigere end 2,4 GHz og har en kortere bølgelænge.
                            Er du tæt på din router, anbefaler vi at bruge 5 GHz, og er du langt fra den, kan du bruge 2,4 GHz.
                        </p>
                    </div>
                    <img
                        className="paragraph-image no-br"
                        src={imageMap.help.network.frekvenserRaekkevidde}
                        alt="Grafik af en router og frekvensernes fordele og ulemper."
                    />
                </div>

                <div className="article article--2">
                    <div className={'text-box text-box--match-height text-box--space-between'}>
                        <div className="paragraph">
                            <h3>Brug 2,4&nbsp;GHz på enheder længere væk fra routeren</h3>
                            <ul className="list list--bullet">
                                <li><p>Lavere hastighed</p></li>
                                <li><p>Lang bølgelængde</p></li>
                                <li><p>Brug den, hvis din enhed er langt væk fra routeren</p></li>
                                <li><p>Brug den, hvis der er vægge eller gulve mellem router og enhed</p></li>
                            </ul>
                        </div>
                        <img
                            className="paragraph-image no-br"
                            src={imageMap.help.network.raekkevidde2g}
                            alt="Grafik af plantegning hvor styrke og hastighed af 2,4 GHz signalet er visualiseret."
                        />
                    </div>
                    <div className={'text-box text-box--match-height text-box--space-between'}>
                        <div className="paragraph">
                            <h3>Brug 5&nbsp;GHz på enheder, der er tæt på din router</h3>
                            <ul className="list list--bullet">
                                <li><p>Højere hastighed</p></li>
                                <li><p>Kort bølgelængde</p></li>
                                <li><p>Brug den, hvis din enhed er tæt på routeren</p></li>
                            </ul>
                        </div>
                        <img
                            className="paragraph-image no-br"
                            src={imageMap.help.network.raekkevidde5g}
                            alt="Grafik af plantegning hvor styrke og hastighed af 5 GHz signalet er visualiseret."
                        />
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h3>Ved du ikke, hvilket netværk der er 2,4&nbsp;GHz eller 5&nbsp;GHz?</h3>
                        <p>
                            Så hedder dine to signaler muligvis det samme.
                            Vi anbefaler, at du navngiver dem med to forskellige navne.
                        </p>
                        <p>
                            Se hvordan i nedenstående guide.
                        </p>
                        <div className={'button-container'}>
                            <Link
                                className={'button button--montserrat with-icon teal'}
                                to={'/hjaelp/internet-og-wifi/skift-navn-og-kode-paa-wifi'}
                            >
                                <span className={'text'}>Skift navn og kode på wifi</span>
                                <Icon component={IconArrow}/>
                            </Link>
                        </div>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "netvaerkskanaler",
                        "name": "Netværkskanaler"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "skift-navn-og-kode-paa-wifi",
                        "name": "Skift navn og kode på wifi"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forventninger-til-wifi",
                        "name": "Hvad kan jeg forvente af mit wifi?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    }
                ]}
            />
        </>
    )
}
